export const otaConnectWizard = {
  google: {
    lead: "Najpierw sprawdzamy, czy dane obiektu są kompletne: Google nie ma ekstranetu i pokazuje tylko to, co mu wyślemy.",
    goConnect: "Kontynuuj w Channex",
    nextIsChannex: "Ostatni krok, czyli wybór pokoi i stawek widocznych w Google, odbywa się na ekranie Channex, który otworzy się za chwilę.",
    typeLabel: "Jakiego rodzaju jest to miejsce?",
    hotel: "Hotel",
    hotelHint: "Z kilkoma pokojami",
    vr: "Wynajem wakacyjny",
    vrHint: "Cały dom lub apartament",
    checking: "Sprawdzanie danych obiektu…",
    ready: "Gotowe: Google może opublikować ten obiekt.",
    missing: "Brakuje 1 rzeczy przed połączeniem | Brakuje {count} rzeczy przed połączeniem | Brakuje {count} rzeczy przed połączeniem",
    canFix: "Część z tych danych już mamy zapisaną i możemy je przesłać automatycznie.",
    prepare: "Przygotuj ofertę",
    prepareFailed: "Nie udało się przygotować oferty.",
    checkFailed: "Nie udało się sprawdzić oferty.",
    cancelLabel: "Zasady anulowania",
    cancelFree: "Bezpłatne anulowanie",
    cancelNon: "Bez możliwości zwrotu",
    bedrooms: "Sypialnie",
    beds: "Łóżka",
    bathrooms: "Łazienki",
  },
  common: {
    close: "Zamknij",
  },
  intro: {
    imageAlt: "Zanim połączysz Booking.com, weź to pod uwagę",
    continue: "Rozumiem, kontynuuj",
  },
  header: {
    edit: "Edytuj",
    connect: "Połącz",
    guidedStep: "Konfiguracja krok po kroku · krok {current} z {total}",
  },
  steps: {
    connection: "Połączenie",
    rooms: "Pokoje",
    rates: "Stawki",
    review: "Podsumowanie",
    done: "Gotowe",
  },
  fields: {
    hotel_id: { label: "ID hotelu", hint: "Znajdziesz go w ekstranecie OTA, w prawym górnym rogu." },
    hotel_code: { label: "Kod hotelu", hint: "Identyfikator obiektu w OTA." },
    property_id: { label: "ID obiektu", hint: "" },
    listing_id: { label: "ID oferty", hint: "" },
    property_code: { label: "Kod obiektu", hint: "" },
    username: { label: "Nazwa użytkownika", hint: "Nazwa użytkownika do logowania w ekstranecie OTA." },
    user: { label: "Nazwa użytkownika", hint: "Nazwa użytkownika do logowania w ekstranecie OTA." },
    password: { label: "Hasło", hint: "Hasło do ekstranetu OTA." },
    api_key: { label: "Klucz API", hint: "Udostępnia go OTA." },
    agent_id: { label: "ID agenta", hint: "" },
  },
  step0: {
    lead: "Wklej identyfikator obiektu w tym kanale. Zweryfikujemy go od razu.",
    loadingChannel: "Wczytywanie wymagań kanału…",
    notAvailable: "Ten kanał nie jest jeszcze dostępny w trybie krok po kroku przez API.",
    oauthText: "{name} łączy się z kontem przez bezpieczne logowanie. Po kliknięciu otworzymy {name} w nowej karcie, aby udzielić autoryzacji; po powrocie połączenie pojawi się na liście kanałów.",
    oauthConnect: "Połącz z {name}",
    oauthOpened: "Otworzyliśmy {name} w nowej karcie. Udziel tam autoryzacji, a połączenie pojawi się na liście kanałów.",
    currencyLabel: "Waluta",
    currencyTooltip: "Kanał ustala ją dla obiektu. Uzupełnia się automatycznie podczas weryfikacji połączenia; nie można jej edytować.",
    currencyPlaceholder: "Uzupełni się przy weryfikacji",
    currencyDetected: "Wykryta automatycznie",
    currencyVerifyToDetect: "Zweryfikuj połączenie, aby ją wykryć",
    verified: "Zweryfikowano",
    testConnection: "Testuj połączenie",
    testOk: "Połączenie zweryfikowane. Przejdź do dopasowania pokoi i stawek.",
    testFailedDefault: "Nie udało się zweryfikować połączenia. Sprawdź identyfikator.",
  },
  step1: {
    leadAirbnb: "Dopasuj każdą ofertę Airbnb do jednej ze swoich jednostek.",
    leadOther: "Dopasuj każdy pokój z kanału {channel} do jednostki ze swojej oferty.",
    listingChip: "Oferta: {name}",
    noLimitChip: "Bez limitu kont i obiektów",
    loadingRooms: "Wczytywanie pokoi z kanału…",
    noRooms: "Nie znaleziono pokoi do dopasowania.",
    dupUnitWarning: "Jednostka „{unit}” jest przypisana do więcej niż jednego pokoju w kanale {channel}. Każdy pokój z kanału musi trafić do innego pokoju w systemie: przy takim zapisie {channel} sprzedawałby je wszystkie w tej samej cenie. Popraw to poniżej przed przejściem dalej.",
    searchPlaceholder: "Szukaj…",
    noRoomMatch: "Żaden pokój nie pasuje do „{query}”.",
    copied: "Skopiowano",
    copyId: "Kopiuj ID: {id}",
    rateCountMeta: "{channel} · stawki: {count}",
    edit: "Edytuj",
    disconnect: "Odłącz",
    unitSearchPlaceholder: "Szukaj jednostki lub oferty…",
    noMatch: "Brak dopasowań",
    cancel: "Anuluj",
  },
  step2: {
    lead: "Główna stawka każdego pokoju uzupełnia się automatycznie ze stawki w kanale {channel}. Jeśli pokój ma kilka stawek, ustal, o ile procent więcej (lub mniej) będzie kosztować każda z nich.",
    crossedFixed: "Jedna stawka została dopasowana do innego pokoju, przez co {channel} sprzedawałby w błędnej cenie. Przywrócono własną stawkę każdego pokoju: sprawdź je przed przejściem dalej. | {count} stawki zostały dopasowane do innego pokoju, przez co {channel} sprzedawałby w błędnej cenie. Przywrócono własną stawkę każdego pokoju: sprawdź je przed przejściem dalej. | {count} stawek zostało dopasowanych do innego pokoju, przez co {channel} sprzedawałby w błędnej cenie. Przywrócono własną stawkę każdego pokoju: sprawdź je przed przejściem dalej.",
    noRates: "Nie znaleziono stawek do dopasowania.",
    yourPct: "Twój % dla tego pokoju",
    auto: "Automatycznie",
    changePct: "Zmień %",
    multiRateAlert: "Ten pokój ma kilka stawek. Ustal, o ile procent więcej (lub mniej) zapłacą goście za każdą z nich, jeśli zarezerwują przez {channel}.",
    minStayOnApply: "Zapisuje się po kliknięciu „Zastosuj”.",
    minStayMissing: "Brak własnego minimalnego pobytu: {channel} sprzedaje ją z minimum taryfy głównej",
    setMinStay: "Ustaw minimalny pobyt",
    nights: "{n} noc | {n} noce | {n} nocy",
    minNights: "min. {n} noc | min. {n} noce | min. {n} nocy",
    minInherited: "min. taryfy głównej",
    ownPlanSummary: "własna cena i minimum",
    minStayNotDerived: "Nie ustawiono minimalnego pobytu ({nights}): „{rate}” to taryfa główna i ma własny minimalny pobyt. Aby {channel} wymagał minimum {nights} w tej taryfie, zastosuj %, zamiast ją wybierać.",
  },
  step3: {
    lead: "To właśnie połączymy w kanale {channel}. Sprawdź i kliknij Połącz.",
    channelCurrency: "Waluta kanału:",
    chargesNote: "Check-in/check-out oraz opłaty (sprzątanie itp.) pobierane są z ustawień obiektu.",
  },
  done: {
    titleConnected: "Połączono: {name}!",
    titleUpdated: "Zaktualizowano: {name}!",
    subActive: "Kanał jest aktywny: synchronizujemy już ceny i dostępność.",
    subPaused: "Kanał jest połączony, ale wstrzymany. Włącz go, aby rozpocząć synchronizację cen i dostępności.",
    subUpdated: "Mapowanie kanału zostało zaktualizowane.",
    notificationSent: "Powiadomienie wysłane",
    syncing: "Synchronizacja…",
    paused: "Wstrzymany",
    activateTitle: "Włącz kanał",
    activateDesc: "Rozpoczyna wysyłanie cen i dostępności do kanału {channel}.",
    activateBtn: "Włącz kanał",
    activated: "Włączony",
    loadReservationsTitle: "Importuj przyszłe rezerwacje",
    loadReservationsDesc: "Przenosi do WACheckin rezerwacje, które już są w kanale {channel}.",
    imported: "Zaimportowano",
    extract: "Importuj",
  },
  rates: {
    mainRate: "Stawka główna",
    standardRate: "Stawka standardowa",
  },
  rooms: {
    listingFallback: "Oferta {id}",
    unitFallback: "jednostka",
  },
  buttons: {
    back: "Wstecz",
    saveChanges: "Zapisz zmiany",
    connect: "Połącz",
    finish: "Zakończ",
    continue: "Kontynuuj",
  },
  errors: {
    dupUnit: "Jednostka „{unit}” jest przypisana do więcej niż jednego pokoju w kanale {channel}. Każdy pokój musi trafić do innej jednostki.",
    crossedBlocked: "Jedna stawka jest dopasowana do innego pokoju ({list}). Wróć do kroku ze stawkami i wybierz własną stawkę każdego pokoju: przy takim zapisie {channel} sprzedawałby w błędnej cenie. | {count} stawki są dopasowane do innego pokoju ({list}). Wróć do kroku ze stawkami i wybierz własną stawkę każdego pokoju: przy takim zapisie {channel} sprzedawałby w błędnej cenie. | {count} stawek jest dopasowanych do innego pokoju ({list}). Wróć do kroku ze stawkami i wybierz własną stawkę każdego pokoju: przy takim zapisie {channel} sprzedawałby w błędnej cenie.",
    dupRate: "Stawka „{rate}” jest dopasowana do więcej niż jednego pokoju w kanale {channel} ({rooms}). Każdy pokój musi mieć własną stawkę: przy takim zapisie sprzedawałyby się w tej samej cenie.",
    roomJoiner: " i ",
    dupRateFallback: "stawka",
    dupUnitFallback: "ta jednostka",
    needRate: "Dopasuj co najmniej jedną stawkę przed połączeniem.",
    updateFailed: "Nie udało się zaktualizować połączenia.",
    createFailed: "Nie udało się utworzyć połączenia.",
    unmapFailed: "Nie udało się odłączyć oferty.",
    needAirbnbMap: "Dopasuj co najmniej jedną ofertę do jednostki.",
    unitNoChannexRate: "Jednostka „{unit}” nie ma stawki z identyfikatorem Channex.",
    airbnbSaveFailed: "Nie udało się zapisać dopasowań Airbnb.",
    actionFailed: "Nie udało się wykonać tej akcji.",
    oauthLinkFailed: "Nie udało się wygenerować linku do połączenia.",
    testFailed: "Błąd podczas testowania połączenia.",
    testNoVerify: "Ten kanał nie wymaga wcześniejszej weryfikacji.",
    rateCreateFailedNeedStandard: "Nie udało się utworzyć stawki. Sprawdź, czy jednostka ma stawkę standardową.",
    rateCreateFailed: "Nie udało się utworzyć stawki.",
    minStaySaveFailed: "Wybrano „{rate}”, ale nie udało się zapisać jej minimalnego pobytu ({nights}): zostaje poprzedni.",
  },
};
